import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Editor from "shared/components/Editor/Editor";
import { FlexContainer } from "shared/cx-components/cx-components.style";
import PersonaDropdown from "shared/dropdowns/library-dropdown/persona/PersonaDropdown";
import TouchpointDropdown from "shared/dropdowns/library-dropdown/TouchpointDropdown";
import { useItem } from "shared/dynamic-imports";
import { GenericDropdown } from "shared/ui-basics";
import LabelDisplay from "shared/ui-basics/ui-components/LabelDisplay";
import { EMPTY_GUID } from "utils/helpers";
import { ConnectorSource } from "utils/optionsSets/OptionSets";

export default function DetailPanelFeedBack(): JSX.Element {
    const { t } = useTranslation();

    const { currentItem, handleBlur, handleChange } = useItem();
    const metricsData = useSelector((state) => state.libraries.cxMetrics)?.FormatDropDownArray();
    const isReadOnly = useSelector(({ auth }: any) => auth.userInfo.UserType)?.isReadOnly();

    metricsData?.unshift({ id: 0, value: t("NO_VALUE") });
    const isDisable = isReadOnly || currentItem?.retrieveData;//isViewer
    const isManual = currentItem?.source === ConnectorSource.Manual;

    return <>
        <LabelDisplay label={"ASPX_98"} icon="PERSONA">
            <div className="pt-2">
                <PersonaDropdown
                    object={currentItem}
                    recordType={'cem_customerexperience'}
                    isSwitchDisabled={true}
                />
            </div>
        </LabelDisplay>
        <LabelDisplay label={"LINKED_TOUCHPOINTS"} icon="circle-dot">
            <TouchpointDropdown
                object={{ ...currentItem, linkedTouchpoints: currentItem?.touchPointId && currentItem?.touchPointId !== EMPTY_GUID ? [currentItem?.touchPointId] : [] }}
                link={(id: string) => handleChange("touchPointId", id, true)}
                unlink={(id: string) => handleChange("touchPointId", EMPTY_GUID, true)}
                isSwitchDisabled={isDisable}
                isCloseWhenSelected={true}
            />
        </LabelDisplay>
        <LabelDisplay label={"CX_METRICS"} icon="gauge-simple-high">
            <div className="pt-2">
                <GenericDropdown
                    name="cxMetricsId"
                    disabled={isDisable}
                    options={metricsData}
                    placeholder={isDisable ? t("EMPTY") : t("SELECT_CXMETRIC")}
                    value={currentItem?.cxMetricsId}
                    onClick={(e: { target: { value: string } }) => handleChange("cxMetricsId", e.target.value, true)}
                    ishoverborder={(!isDisable && true).toString()}
                />
            </div>
        </LabelDisplay>
        {isManual && <LabelDisplay label={"SOURCE"} icon="link">
            <div className="pt-2">
                <FlexContainer focus className="p-1">
                    <Editor
                        value={currentItem?.sourceDescription || ""}
                        onChange={(value: string) => handleChange("sourceDescription", value)}
                        onUpdate={() => handleBlur("sourceDescription")}
                        placeholder={t("EMPTY")}
                        disabled={isDisable}
                    />
                </FlexContainer>
            </div>
        </LabelDisplay>

        }
    </>
}

